import { render, staticRenderFns } from "./SubscriptionsTab.vue?vue&type=template&id=48d8f31c&scoped=true&lang=pug"
import script from "./SubscriptionsTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTab.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsTab.vue?vue&type=style&index=0&id=48d8f31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8f31c",
  null
  
)

export default component.exports